var _defs, _g, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShipSpeederWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3f8ff;\n      }\n\n      .cls-2 {\n        fill: #301d29;\n      }\n\n      .cls-3 {\n        fill: #3a2834;\n      }\n\n      .cls-4 {\n        fill: #3f2738;\n      }\n\n      .cls-5 {\n        fill: #4c3547;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "230.67 333.41 434.69 359.25 495.45 375.14 211.19 361.45 230.67 333.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "230.67 333.41 255.77 314.7 434.69 359.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "228.71 383.79 455.85 383.79 495.45 375.14 211.02 361.14 228.71 383.79"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "384.12 391.95 447.58 391.95 456.02 384.1 375.68 384.1 384.12 391.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "237.21 391.75 300.66 391.75 309.11 383.9 228.77 383.9 237.21 391.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "331.77 366.7 495.62 375.45 434.86 359.56 230.77 333.7 331.77 366.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShipSpeederWhite);
export default __webpack_public_path__ + "static/media/bg-ship-speeder-white.0492d5b2a7942ee0758e284c6032b88d.svg";
export { ForwardRef as ReactComponent };